export default "__VITE_ASSET__H6$fWbmb__"